import type { FaireProductEntity } from "../../entity_types/product";

export const p_52q6jrzp4t: FaireProductEntity = {
  token: "p_52q6jrzp4t",
  type: "product",
  name: "Whale Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f7a0cc7b12e98534852f934c3a7970fa5f51ecee8daf116bd7fdf2b13d49eb12.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/59c835abeaa90dc11515150d46760a4e0e80ece1f8554fd0fea99b10afcbc563.jpeg",
    "https://cdn.faire.com/fastly/0b8d803c9028b4f5fc77cc895a7a95014e05ba12065850d5cc6f5109cea9935b.jpeg",
    "https://cdn.faire.com/fastly/f43bf760b938fc6685746ce89e734fa83f8e95d39ecfe5f4eae62bac11bd7500.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:40.708Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
